import { ModifiedWebSocket } from "../utils/websocketModifier.util";
import { IResolverStatic, Resolver } from "../types";

export type IdResolverOptions = {
    session: ModifiedWebSocket;
};

export abstract class IdResolver extends Resolver {
    // Генератор id для функций и requestId вызовов.
    protected options: IdResolverOptions;

    constructor(options: IdResolverOptions) {
        super();
        this.options = options;
    }

    public abstract gen(...params: any[]): Promise<string>;
    public abstract close(): void;
}

export interface IIdResolver extends IResolverStatic {
    new (options: IdResolverOptions): IdResolver;
}
